import { AssetFilterScreen } from '@gripp/shared-ui';

interface AssetFilterModalProps {
  isVisible: boolean;
  onDismiss: () => void;
}

export const AssetFilterModal = ({ isVisible, onDismiss }: AssetFilterModalProps) => (
  <AssetFilterScreen mode="modal" isVisible={isVisible} onDismiss={onDismiss} />
);
